import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';

import { Ride } from '../../types/ride';
import API from '../../api';
import { AppState } from '../../store/interfaces';
import { setIsInitialized, setRoutes } from '../../store/map/actions';

export const useRoutes = (rides?: Ride[]) => {
  const dispatch = useDispatch();
  /*
  const routes = useSelector((app: AppState) => app.map.routes, shallowEqual);

  const map = useMap();

  useEffect(() => {
    (async function () {
      if (!rides) {
        return;
      }

      const routesMap = {};

      try {
        const responses = await Promise.all(
          rides.map((ride) => {
            if (routes[ride.id]) {
              return null;
            }

            return API.routes.get(ride);
          })
        );

        responses.forEach((response, key) => {
          const ride = rides[key];
          if (routes[ride.id]) {
            routesMap[ride.id] = routes[ride.id];
            return;
          }

          const { coordinates } = response!.data.data.raw.routes[0].geometry;

          routesMap[ride.id] = [];
          coordinates.forEach(([lng, lat]) => {
            routesMap[ride.id].push({
              lng,
              lat,
            });
          });
        });

        dispatch(setRoutes(routesMap));
      } catch (e) {
        dispatch(setIsLoading(false));
        return;
      }

      const bounds: any = [];

      rides.forEach((ride) => {
        bounds.push([ride.start_lat, ride.start_lng], [ride.end_lat, ride.end_lng]);
        if (routesMap[ride.id]) {
          bounds.push(...routesMap[ride.id]);
        }
      });

      map.fitBounds(bounds);
      dispatch(setIsLoading(false));
    })();
  }, [rides]);
  */
  useEffect(() => {
    dispatch(setIsInitialized(true));
  }, []);
};
